import {useUpmPlant} from '@hconnect/upm'
import {Button, DashboardCard, GenericInput, H3, Table} from '@hm/fundamental'
import {mdiMagnify, mdiPlus} from '@mdi/js'
import useDebounce from '@react-hook/debounce'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {AddStaticPartModal} from './StaticPartModal'

import {PageHeaderWithSwitch} from '@refra/modules/common/components'
import {useRefraModal, useKilns, useShutdowns} from '@refra/modules/common/providers'
import {
  useStaticPartsOverviewData,
  useStaticPartsOverviewConfig
} from '@refra/modules/refra-static-parts/hooks'
import {useStaticPartsListQuery} from '@refra/modules/refra-static-parts/hooks/queries'
import {useUrlParam, useUrlParamOptional} from '@refra/modules/routing/hooks'

export const StaticPartsOverview = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const [textFilter, setTextFilter] = useDebounce('', 400)
  const plantId = useUrlParam('plantCode')
  const selectedKilnId = useUrlParamOptional('selectedKilnId')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln, kilnNodes} = useKilns()
  const {openModal} = useRefraModal()
  const {selectedShutdown} = useShutdowns()
  const shutdownId = selectedShutdown?.id.toString()

  const staticPartsConfig = useStaticPartsOverviewConfig()
  const {data} = useStaticPartsListQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId,
    shutdownId: shutdownId
  })

  const staticPartsData = useStaticPartsOverviewData({staticParts: data, textFilter})
  const baseStaticPartDetailPath = selectedKilnId ? '' : `${selectedKiln.upmId}/`
  const query = new URLSearchParams(shutdownId ? {shutdownId} : {}).toString()

  return (
    <>
      <PageHeaderWithSwitch kilnNodes={kilnNodes} titleKey={'staticParts.title'} />
      <DashboardCard data-cy="refra_static_parts_card">
        <div className="flex flex-col gap-6">
          <div className="flex justify-between content-center">
            <H3>{t('staticParts.overview')}</H3>
            <div className="flex gap-4 content-center justify-center">
              <GenericInput
                name="refra_static_parts_filter"
                defaultValue={textFilter}
                icon={mdiMagnify}
                placeholder={t('staticParts.filterPlaceholder')}
                onChange={(text) => setTextFilter(text)}
                data-cy="refra_static_parts_filter"
                className="h-full"
              />
              <Button icon={mdiPlus} onClick={() => openModal(<AddStaticPartModal />)} size="small">
                {t('staticParts.add')}
              </Button>
            </div>
          </div>
          <Table
            config={staticPartsConfig}
            data={staticPartsData}
            breakpoint="sm"
            data-cy="refra_static_parts_overview_table"
            onRowClick={(staticPartsData) =>
              navigate(
                `${baseStaticPartDetailPath}${staticPartsData.id}${query ? `?${query}` : ''}`
              )
            }
          />
        </div>
      </DashboardCard>
    </>
  )
}
